import { FormEvent, useState } from "react";
import type { ProductSource, SourceMode } from "../../shared/types";
import { api, ApiError } from "../api";

export function SourceForm({ onComplete }: { onComplete: (source: ProductSource) => void }) {
  const [mode, setMode] = useState<SourceMode>("url");
  const [url, setUrl] = useState("");
  const [content, setContent] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      const source = await api<ProductSource>("/api/ingest", {
        method: "POST",
        body: JSON.stringify(mode === "url" ? { mode, url } : { mode, content })
      });
      onComplete(source);
    } catch (cause) {
      setError(cause instanceof ApiError ? cause.message : "目前無法整理商品資料。");
    } finally {
      setBusy(false);
    }
  }

  return (
    <section className="panel source-panel">
      <div className="section-heading">
        <span className="step-number">1</span>
        <div><p className="eyebrow">提供資料</p><h2>先讓系統理解商品</h2></div>
      </div>
      <div className="segmented" role="tablist" aria-label="資料來源">
        <button className={mode === "url" ? "active" : ""} onClick={() => setMode("url")} type="button">商品頁網址</button>
        <button className={mode === "manual" ? "active" : ""} onClick={() => setMode("manual")} type="button">手動貼上</button>
      </div>
      <form onSubmit={submit}>
        {mode === "url" ? (
          <label>商品頁網址
            <input type="url" placeholder="https://example.com/products/..." value={url} onChange={(event) => setUrl(event.target.value)} required />
          </label>
        ) : (
          <label>商品資料
            <textarea rows={10} maxLength={20000} placeholder="請貼上商品名稱、材質、規格、特色、使用情境、適用對象、檢驗或認證資料…" value={content} onChange={(event) => setContent(event.target.value)} required />
            <span className="counter">{content.length.toLocaleString()} / 20,000</span>
          </label>
        )}
        {error && <p className="form-error" role="alert">{error}</p>}
        <button className="primary-button" disabled={busy || (mode === "url" ? !url : !content.trim())}>
          {busy ? "正在整理資料…" : "整理商品資料"}
        </button>
      </form>
    </section>
  );
}
